/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SyncStatus {
    Missing = 0,
    Queued = 1,
    Running = 2,
    Synced = 3,
}
